import { ProgramValidation } from './program-validation';

export class ProgramInput {
  public description: string;
  public labelText: string;
  public multiple: boolean;
  public required?: boolean;
  public subType?: string;
  public toId?: string;
  public type?: string;
  public minValue?: number;
  public maxValue?: number;
  public name?: string;
  public validation?: ProgramValidation;
}
